import React, { useEffect, useRef, useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { storeIdAction } from "../../../redux/actions/general-action";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { storeDetailsAction } from "../../../redux/actions/invoices-action";
import successToast from "../../helper-components/success-toast";
import errorToast from "../../helper-components/error-toast";
import {
  salesCreateAction,
  salesEditAction,
} from "../../../redux/actions/sales-action";
import moment from "moment";
import { handlea4Print } from "../../helper-components/helper-function";
import SalesPurchaseNavbar from "../sales-purchase-navbar";
import SalesPurchaseFooter from "../sales-purchase-footer";
import SalesOrderItemsSec from "./sales-order-items-sec";

const CreateEditViewSalesOrder = ({
  orderDetail = [],
  vendorDetails = [],
  disabled = false,
  page = "",
  data,
  pageType,
  isClone = false,
  isNotViewOnly = true,
}) => {
  const [heading, setHeading] = useState([]);

  const [buttonLoading, setButtonLoading] = useState(false);
  const isDispatchingRef = useRef(false);
  const submitScheduledRef = useRef(false);
  const rowData = useSelector((state) => state.invoiceRowReducer);
  const searchRef = useRef(null);

  console.log("vendorDetails", orderDetail);


  const initialData = {
    sl_no: 1,
    item_name: "",
    item_generic_name: "",
    item_code: "",
    item_manufacturer_name: "",
    item_return_availability: "",
    item_uom: "",
    total_sellable_quantity: 0,
    item_requested_quantity: 0,
    quantity: 0,
    item_unit_price: 0,
    item_min_max: "",
    item_total_amount: 0,
    item_id: "",
    item_tax_amount: 0,
    item_gst: 0,
    item_sgst: 0,
    item_cgst: 0,
    item_igst: 0,
    item_price_wiithout_tax: 0,
    item_uom_id: "",
    item_minimun_purchasing: "",
    item_maximum_purchasing: "",
    pot_id: null,
    pos_id: null,
  };
  const initialFormValues = {
    cmr_code: vendorDetails?.[0]?.cmr_id
      ? {
          label: vendorDetails?.[0]?.cmr_code ?? "",
          value: vendorDetails?.[0]?.cmr_id ?? "",
        }
      : "",
    cmr_name: vendorDetails?.[0]?.cmr_id
      ? {
          label: vendorDetails?.[0]?.cmr_name,
          value: vendorDetails?.[0]?.cmr_id,
        }
      : "",
    cmr_id: vendorDetails?.[0]?.cmr_id,
    remarks: vendorDetails?.[0]?.remarks ?? "",
    // customer_invoice_number: vendorDetails?.[0]?.customer_invoice_number ?? null,
    sott_total_discount: vendorDetails?.[0]?.sott_total_discount ?? 0,
    sott_order_date: vendorDetails?.[0]?.sott_order_date && !isClone
      ? moment(vendorDetails?.[0]?.sott_order_date).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD"),
    sott_document_date: vendorDetails?.[0]?.sott_document_date && !isClone
      ? moment(vendorDetails?.[0]?.sott_document_date).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD"),
    sott_delivery_date: vendorDetails?.[0]?.sott_delivery_date && !isClone
      ? moment(vendorDetails?.[0]?.sott_delivery_date).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD"),
    sott_round_off_value: vendorDetails?.[0]?.sott_round_off_value ?? 0,
    sott_id: vendorDetails?.[0]?.sott_id ?? "",
    pot_id: vendorDetails?.[0]?.pot_id ?? null,
    pos_id: vendorDetails?.[0]?.pos_id ?? null,
    sott_order_status: vendorDetails?.[0]?.sott_order_status ?? "",
    sott_sub_total: vendorDetails?.[0]?.sott_sub_total || "0.00",
    sott_total_gst: vendorDetails?.[0]?.sott_total_gst || "0.00",
    sott_total_amount: vendorDetails?.[0]?.sott_total_amount || "0.00",
    sott_pay_to_address: vendorDetails?.[0]?.sott_pay_to_address || null, //new
    sott_ship_to_address: vendorDetails?.[0]?.sott_ship_to_address || null, //new
    is_inter_state:vendorDetails?.[0]?.gst_type === "Inter"?true:vendorDetails?.[0]?.gst_type === "Intra"?false:null,
    data: [
      ...orderDetail?.map((item, index) => ({
        sl_no: index + 1,
        item_name: item?.item_name ?? "",
        item_generic_name:
        item?.item_generic_name === null ? "" : item?.item_generic_name,
        item_code: item?.item_code ?? "",
        item_manufacturer_name: item?.item_manufacturer_name,
        item_return_availability: "--",
        item_uom: item?.item_uom ?? "--",
        total_sellable_quantity: item?.total_sellable_quantity,
        item_requested_quantity: item?.item_requested_quantity,
        quantity: item?.item_quantity,
        item_unit_price: item?.item_unit_price ?? 0,
        item_min_max: item?.item_min_max,
        item_total_amount: item?.item_total_amount,
        item_id: item?.item_id,
        item_tax_amount: item?.item_tax_amount,
        instock: true,
        item_gst: item?.item_gst,
        item_cgst: item?.item_cgst,
        item_sgst: item?.item_sgst,
        uom_dropdown: item?.uom_dropdown
          ? item?.uom_dropdown.map((uom) => ({
              base_quantity: uom?.base_quantity ?? 1,
              item_uom_id: uom?.item_id,
              label: uom?.alt_uom,
              value: uom?.alt_uom,
            }))
          : [],
        item_uom_id: item?.item_uom_id ?? "",
        item_manufacturer_id: item?.item_manufacturer_id ?? "",
        item_minimun_purchasing: item?.item_minimun_purchasing ?? "",
        item_maximum_purchasing: item?.item_maximum_purchasing ?? "",
        pot_id: item?.pot_id ?? vendorDetails?.[0]?.pot_id,
        pos_id: item?.pos_id ?? vendorDetails?.[0]?.pos_id,
        item_hsn: item.item_hsn,
      })),
      initialData,
    ],
  };
  const [initialValue, setInitialValue] = useState(initialFormValues);
  const [reload, setReload] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [storeId, setStoreId] = useState("");
  const [storeDetails, setStoreDetails] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const validationSchema = Yup.object().shape({
    cmr_code: Yup.object().required("Customer code number is required"),
    cmr_name: Yup.object().required("Customer name is required"),
    sott_document_date: Yup.string().required("Document date is required"),
    sott_delivery_date: Yup.string().required("Delivery date is required"),
  });

  useEffect(() => {
    dispatch(storeIdAction(onSuccessStore, onErrorStore));
    dispatch(storeDetailsAction(onSuccessStoreDetails, onErrorStoreDetails));
    const data = localStorage.getItem("ModPermission");
    if (data) {
      const parsed = JSON.parse(data);
      const salesdata = parsed.find((obj) => obj?.sales_order_create);
      if (salesdata?.sales_order_create) {
        const cols = [...salesdata.sales_order_create];
        if (!cols.some((c) => c.value === "item_pack_size")) {
          const qtyIdx = cols.findIndex((c) => c.value === "quantity");
          const insertAt = qtyIdx !== -1 ? qtyIdx + 1 : cols.length;
          cols.splice(insertAt, 0, {
            label: "Unit Qty",
            value: "item_pack_size",
            minWidth: 80,
            alignment: "right",
          });
        }
        setHeading(cols);
      }
    }
  }, []);
  const onSuccessStore = (data) => {
    setStoreId(data?.data?.store_id);
    setReload(!reload);
  };
  const onErrorStore = () => {};
  const onSuccessStoreDetails = (data) => {
    setStoreDetails(data?.data);
    const storeData=data?.data;
    const storeState=storeData?.store_state;
    const store_state=storeState?.toLowerCase()?.trim();
    if(store_state===null || store_state===undefined || store_state?.trim()===""){
        errorToast("Please configure store state in store deatils")
        return;
    }
  };
  const onErrorStoreDetails = () => {};

  const handleSubmit = (values) => {
    // Block duplicate submissions while a request is already in flight.
    if (isDispatchingRef.current) return;
    let actionType = salesCreateAction;
    const missingUOM = values?.data
      ?.slice(0, -1)
      .some((item) => !item.item_uom);
    if (page === "edit") {
      actionType = salesEditAction;
    }
    if(!values?.sott_pay_to_address){
      errorToast("Please verify and save the address");
          return;
    }
    if(!values?.sott_ship_to_address){
      errorToast("Please verify and save the address");
          return;
    }
    if (
      values?.data
        ?.slice(0, -1)
        .some(
          (item) => parseInt(item.quantity) === 0 || item.quantity === ""
        ) &&
      values?.submittedButton !== "draft"
    ) {
      errorToast("Quantity cannot be zero");
    } else if (missingUOM && values?.submittedButton !== "draft") {
      errorToast("Please add UOM for all items");
    } else {
      if (values?.data?.length > 1) {
        isDispatchingRef.current = true;
        setButtonLoading(true);
        dispatch(
          actionType(
            {
              orderData: {
                // ...(page !== "add" ? { item_uom_id: values?.item_uom_id } : {}),

                is_draft_order:
                  values.submittedButton === "draft" ? true : false,
                ...(values?.sott_id ? { sott_id: values?.sott_id } : {}),
                store_id: storeId,
                sott_total_gst: values?.sott_total_gst,
                sott_total_discount: values?.sott_total_discount ?? 0,
                sott_payment_status: "paid",
                sott_transaction_id: "",
                sott_billing_address: "",
                sott_total_amount: values?.sott_total_amount,
                cmr_code: values?.cmr_code?.label,
                cmr_id: values?.cmr_id,
                cmr_name: values?.cmr_name?.label,
                remarks: values?.remarks,
                sott_order_date: values?.sott_order_date,
                sott_document_date: values?.sott_document_date,
                sott_delivery_date: values?.sott_delivery_date,
                pot_id: values?.pot_id ?? null,
                pos_id: values?.pos_id ?? null,
                sott_round_off_value: values?.sott_round_off_value,
                sott_pay_to_address: values?.sott_pay_to_address || null, //new
                sott_ship_to_address: values?.sott_ship_to_address || null, //new,
                gst_type: values?.is_inter_state === false ? "Intra" : values?.is_inter_state === true ? "Inter" : null,
                // customer_invoice_number: values?.customer_invoice_number,
                sott_sub_total:values?.sott_sub_total
              },
              itemData: values?.data?.slice(0, -1).map((item, index) => ({
                item_name: item?.item_name ?? "",
                item_id: item?.item_id,
                item_generic_name: item?.item_generic_name,
                item_code: item?.item_code ?? "",
                item_manufacturer_name: item?.item_manufacturer_name ?? "",
                // item_return_availability: parseInt(item?.item_return_availability),
                item_uom: item?.item_uom ?? "--",
                item_quantity: item?.quantity,
                // total_sellable_quantity: item?.total_sellable_quantity,
                item_unit_price: item?.item_unit_price ?? 0,
                // ...(type === "sales"
                //   ? { sales_order_qty: item?.item_quantity ?? 0 }
                //   : {}),
                // item_min_max: item?.item_min_max,
                item_total_amount: item?.item_total_amount,
                ...(values?.sott_id ? { sott_id: values?.sott_id } : {}),
                item_minimun_purchasing: item?.item_minimun_purchasing
                  ? parseInt(item?.item_minimun_purchasing)
                  : "",
                item_maximum_purchasing: item?.item_maximum_purchasing
                  ? parseInt(item?.item_maximum_purchasing)
                  : "",
                item_tax_amount: parseFloat(item?.item_tax_amount),
                item_gst: parseFloat(item?.item_gst),
                item_sgst: values?.is_inter_state === true ? 0 : parseFloat(item?.item_sgst || 0),
                item_cgst: values?.is_inter_state === true ? 0 : parseFloat(item?.item_cgst || 0),
                item_igst: values?.is_inter_state === true ? parseFloat(item?.item_igst || item?.item_tax_amount || 0) : 0,
                item_uom_id: item?.item_uom_id ?? "",
                pot_id: item?.pot_id ?? values?.pot_id??null,
                pos_id: item?.pos_id ?? values?.pot_id??null,
                item_hsn: item?.item_hsn ?? "",
              })),
            },
            onSuccessOrder,
            onErrorOrder
          )
        );
      }
    }
  };

  const onSuccessOrder = (data) => {
    isDispatchingRef.current = false;
    setButtonLoading(false);
    if (formValues?.submittedButton === "print") {
      handlea4Print(data?.data?.orderData?.sott_id, "sales_order", dispatch);
    }
    navigate("/sales");
    successToast(data?.message);
    setInitialValue({
      cmr_code: "",
      cmr_name: "",
      cmr_id: "",
      remarks: "",
      sott_total_discount: 0,
      sott_order_date: null,
      sott_document_date: null,
      sott_delivery_date: null,
      data: [initialData],
    });
  };
  const onErrorOrder = () => {
    isDispatchingRef.current = false;
    setButtonLoading(false);
  };
  const autoDraft = (values) => {
    if (isDispatchingRef.current) return;
    let actionType = salesCreateAction;
    const missingUOM = values?.data
      ?.slice(0, -1)
      .some((item) => !item.item_uom);
    if (page === "edit") {
      actionType = salesEditAction;
    }
    if (
      values?.data
        ?.slice(0, -1)
        .some(
          (item) => parseInt(item.quantity) === 0 || item.quantity === ""
        ) &&
      values?.submittedButton !== "draft"
    ) {
      errorToast("Quantity cannot be zero");
    } else if (missingUOM && values?.submittedButton !== "draft") {
      errorToast("Please add UOM for all items");
    } else {
      const hasItems = (values?.data?.length ?? 0) > 1;
      if (hasItems) {
        isDispatchingRef.current = true;
        setButtonLoading(true);
        dispatch(
          actionType(
            {
              orderData: {
                // ...(page !== "add" ? { item_uom_id: values?.item_uom_id } : {}),

                is_draft_order: true,
                ...(values?.sott_id ? { sott_id: values?.sott_id } : {}),
                store_id: storeId,
                sott_total_gst: values?.sott_total_gst,
                sott_total_discount: values?.sott_total_discount ?? 0,
                sott_payment_status: "paid",
                sott_transaction_id: "",
                sott_billing_address: "",
                sott_total_amount: values?.sott_total_amount,
                cmr_code: values?.cmr_code?.label,
                cmr_id: values?.cmr_id,
                cmr_name: values?.cmr_name?.label,
                remarks: values?.remarks,
                sott_order_date: values?.sott_order_date,
                sott_document_date: values?.sott_document_date,
                sott_delivery_date: values?.sott_delivery_date,
                pot_id: values?.pot_id ?? null,
                pos_id: values?.pos_id ?? null,
                sott_round_off_value: values?.sott_round_off_value,
                sott_pay_to_address: values?.sott_pay_to_address || null, //new
                sott_ship_to_address: values?.sott_ship_to_address || null, //new
                gst_type: values?.is_inter_state === false ? "Intra" : values?.is_inter_state === true ? "Inter" : null,
                // customer_invoice_number: values?.customer_invoice_number,
              },
              itemData: values?.data?.slice(0, -1).map((item, index) => ({
                item_name: item?.item_name ?? "",
                item_id: item?.item_id,
                item_generic_name: item?.item_generic_name,
                item_code: item?.item_code ?? "",
                item_manufacturer_name: item?.item_manufacturer_name ?? "",
                // item_return_availability: parseInt(item?.item_return_availability),
                item_uom: item?.item_uom ?? "--",
                item_quantity: item?.quantity,
                // total_sellable_quantity: item?.total_sellable_quantity,
                item_unit_price: item?.item_unit_price ?? 0,
                // ...(type === "sales"
                //   ? { sales_order_qty: item?.item_quantity ?? 0 }
                //   : {}),
                // item_min_max: item?.item_min_max,
                item_total_amount: item?.item_total_amount,
                item_minimun_purchasing: item?.item_minimun_purchasing
                  ? parseInt(item?.item_minimun_purchasing)
                  : "",
                item_maximum_purchasing: item?.item_maximum_purchasing
                  ? parseInt(item?.item_maximum_purchasing)
                  : "",
                item_tax_amount: parseFloat(item?.item_tax_amount),
                item_gst: parseFloat(item?.item_gst),
                item_sgst: values?.is_inter_state === true ? 0 : parseFloat(item?.item_sgst || 0),
                item_cgst: values?.is_inter_state === true ? 0 : parseFloat(item?.item_cgst || 0),
                item_igst: values?.is_inter_state === true ? parseFloat(item?.item_igst || item?.item_tax_amount || 0) : 0,
                item_uom_id: item?.item_uom_id ?? "",
                pot_id: item?.pot_id ?? null,
                pos_id: item?.pos_id ?? null,
                item_hsn: item.item_hsn,
              })),
            },
            (data) => {
              // setLoading(false);
              // resetForm();
              // setPaymentPanel(false);
              // if (values.submittedButton === "print") {
              //   handlea4Print(
              //     data?.data?.orderData?.[0]?.sot_id,
              //     "Billing",
              //     dispatch
              //   );

              //Needed for unwrap
              // handlePrint(data?.data, storeDetails);
              // }
              successToast(data?.message);
              // setLoading(true);
              setTimeout(() => {
                // setLoading(false);
              }, 50);
              navigate(
                `/edit-customer-admin/${values?.cmr_id}?backto=/edit-sales/${data?.data?.orderData?.sott_id}`,
                {
                  state: { tab: "Address" },
                }
              );
              // navigate(
              //   `/add-doctor?doctor=${
              //     selectedOption?.value?.number?.toString() || ""
              //   }&draft=${data?.data?.orderData?.[0]?.sot_id}`
              // );

              // formValuesRef.current = null; // Reset after handling
            },
            (data) => {
              errorToast(data?.data?.message);
            }
          )
        );
      } else {
        navigate(
          `/edit-customer-admin/${values?.cmr_id}?backto=/add-sales/%255B%255D/sales?new`,
          {
            state: { tab: "Address" },
          }
        );
      }
    }
  };
  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={initialValue}
        validationSchema={validationSchema}
        onSubmit={(values, actions) => {
          if (submitScheduledRef.current || isDispatchingRef.current) {
            actions.setSubmitting(false);
            return;
          }
          submitScheduledRef.current = true;
          setButtonLoading(true);
          setTimeout(() => {
            submitScheduledRef.current = false;
            handleSubmit(values, actions); // arms isDispatchingRef on dispatch
            if (!isDispatchingRef.current) {
              setButtonLoading(false);
            }
            actions.setSubmitting(false); // Notify Formik that submission is done
          }, 500);
        }}
      >
        {({ values }) => {
          setFormValues(values);

          return (
            <Form className="h-full">
              <div
                style={{
                  height: `calc(100% - 8rem)`,
                }}
                className="mx-5 flex flex-col h-full "
              >
                <SalesPurchaseNavbar
                  isClone={isClone}
                  autoDraft={autoDraft}
                  pageType={pageType}
                  isCusInvNumRequired={false}
                  section="sales"
                  name="sott"
                  disabled={disabled}
                  searchRef={searchRef}
                  page={page}
                  docType="sales_order"
                  storeDetails={storeDetails}
                  standAlone={true}
                />

                <SalesOrderItemsSec
                  heading={heading}
                  disabled={values.is_inter_state===null || disabled}
                  searchRef={searchRef}
                  initialData={initialData}
                />
              </div>
              <SalesPurchaseFooter
                modules="sales"
                prefixName="sott"
                transaction="Sales Order"
                transaction_type="sales_order"
                buttonLoading={buttonLoading}
                // status={vendorDetails?.[0]?.sott_order_status === "open"}
                name="sott_total_discount"
                page={page}
                disabled={disabled}
                EditFn={() =>
                  navigate(`/edit-sales/${vendorDetails?.[0]?.sott_id}`)
                }
              />
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default CreateEditViewSalesOrder;
